export default __webpack_public_path__ + "static/media/bg-asset.3d514e9f.svg";